import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api/api.service';
import { ITraining } from '@precheckin/models/training/training.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TrainingsService {
  private readonly endpoint = `trainings`;

  constructor(private apiService: ApiService) { }

  public getPrecheckinCurrentTraining(): Observable<ITraining> {
    return this.apiService.get<ITraining>(`${this.endpoint}/current`);
  }

  public getById(id: string): Observable<ITraining> {
    return this.apiService.get<ITraining>(`${this.endpoint}/${id}`);
  }
}
